export default __webpack_public_path__ + "static/Blender-Bold-9f360c685b936aab49e808f346b7ddb8.woff2";